/**
 * Badass Crew — cart drawer synced to Shopify cart
 */
(function () {
  'use strict';

  var drawerEl = null;
  var callbacks = {};
  var moneyFormat = '${{amount}}';
  var freeShipThreshold = 0;
  var upsellProducts = [];
  var isOpen = false;
  var onCloseCallback = null;
  var overlayCloseBlockedUntil = 0;

  function qs(sel) {
    return drawerEl ? drawerEl.querySelector(sel) : null;
  }

  function formatMoney(cents) {
    cents = Math.round(Number(cents) || 0);
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      try {
        return Shopify.formatMoney(cents, moneyFormat);
      } catch (e) {}
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function renderQtyControls(line) {
    var qty = line.quantity || 1;
    var key = escapeHtml(line.key);
    return (
      '<div class="bcc-drawer__item-qty" data-bcc-qty-wrap="' +
      key +
      '">' +
      '<button type="button" class="bcc-drawer__qty-btn" data-bcc-qty-minus="' +
      key +
      '" aria-label="Decrease quantity"' +
      (qty <= 1 ? ' disabled' : '') +
      '>−</button>' +
      '<span class="bcc-drawer__qty-value" data-bcc-qty-value="' +
      key +
      '">' +
      qty +
      '</span>' +
      '<button type="button" class="bcc-drawer__qty-btn" data-bcc-qty-plus="' +
      key +
      '" aria-label="Increase quantity">+</button>' +
      '</div>'
    );
  }

  function lineArticleOpen(line, extraClass) {
    return (
      '<article class="bcc-drawer__item' +
      (extraClass ? ' ' + extraClass : '') +
      '" data-bcc-item="' +
      escapeHtml(line.key) +
      '" data-bcc-qty="' +
      String(line.quantity || 1) +
      '">'
    );
  }

  function renderShipping(totalCents) {
    var textEl = qs('[data-bcc-ship-text]');
    var fillEl = qs('[data-bcc-ship-fill]');
    if (!textEl) return;

    if (!freeShipThreshold || freeShipThreshold <= 0) {
      textEl.textContent = '';
      textEl.hidden = true;
      if (fillEl) fillEl.style.width = '0%';
      return;
    }

    textEl.hidden = false;
    var total = Math.max(0, Number(totalCents) || 0);
    var pct = Math.min(100, (total / freeShipThreshold) * 100);

    if (total >= freeShipThreshold) {
      textEl.textContent = 'You qualify for FREE shipping!';
      textEl.classList.add('is-unlocked');
    } else {
      var remaining = freeShipThreshold - total;
      textEl.textContent = 'Buy ' + formatMoney(remaining) + ' more to enjoy FREE shipping.';
      textEl.classList.remove('is-unlocked');
    }

    if (fillEl) fillEl.style.width = pct + '%';
  }

  function renderLineItem(line) {
    var img = line.image || '';
    var imgHtml = img
      ? '<img class="bcc-drawer__item-img" src="' + escapeHtml(img) + '" alt="" width="72" height="72" loading="lazy">'
      : '<span class="bcc-drawer__item-img bcc-drawer__item-img--empty" aria-hidden="true"></span>';
    var priceHtml = '<p class="bcc-drawer__item-price">';
    if (line.compareCents && line.compareCents > line.priceCents) {
      priceHtml +=
        '<span class="bcc-drawer__item-price-sale">' +
        formatMoney(line.priceCents || 0) +
        '</span> <s class="bcc-drawer__item-compare">' +
        formatMoney(line.compareCents) +
        '</s>';
    } else {
      priceHtml += formatMoney(line.priceCents || 0);
    }
    priceHtml += '</p>';
    var subtitle =
      line.variantTitle && line.variantTitle !== 'Default Title'
        ? '<p class="bcc-drawer__item-variant">' + escapeHtml(line.variantTitle) + '</p>'
        : '';

    return (
      lineArticleOpen(line, 'bcc-drawer__item--single') +
      imgHtml +
      '<div class="bcc-drawer__item-main">' +
      (line.tag ? '<span class="bcc-drawer__bundle-tag">' + escapeHtml(line.tag) + '</span>' : '') +
      '<h3 class="bcc-drawer__item-name">' +
      escapeHtml(line.title || 'Product') +
      '</h3>' +
      subtitle +
      priceHtml +
      renderQtyControls(line) +
      '</div>' +
      '<button type="button" class="bcc-drawer__item-remove" data-bcc-remove-line="' +
      escapeHtml(line.key) +
      '">Remove</button>' +
      '</article>'
    );
  }

  function renderBundleItem(line) {
    if (!line || !line.scents || !line.scents.length) return renderLineItem(line);

    var isSingle = line.scents.length === 1 && line.quantity === 1;
    var img =
      (line.scents[0] && line.scents[0].image) ||
      line.image ||
      '';
    var imgHtml = img
      ? '<img class="bcc-drawer__item-img" src="' + escapeHtml(img) + '" alt="" width="72" height="72" loading="lazy">'
      : '<span class="bcc-drawer__item-img bcc-drawer__item-img--empty" aria-hidden="true"></span>';
    var priceHtml = '<p class="bcc-drawer__item-price">';
    if (line.compareCents && line.compareCents > line.priceCents) {
      priceHtml +=
        '<span class="bcc-drawer__item-price-sale">' +
        formatMoney(line.priceCents || 0) +
        '</span> <s class="bcc-drawer__item-compare">' +
        formatMoney(line.compareCents) +
        '</s>';
    } else {
      priceHtml += formatMoney(line.priceCents || 0);
    }
    priceHtml += '</p>';

    var title = isSingle ? line.scents[0].title || line.title : line.title || 'Custom Bundle';
    var scentList = isSingle
      ? ''
      : '<ul class="bcc-drawer__scents" role="list">' +
        line.scents
          .map(function (scent) {
            return (
              '<li class="bcc-drawer__scent">' +
              '<span class="bcc-drawer__scent-name">' +
              escapeHtml(scent.title || 'Scent') +
              '</span>' +
              (line.canEditScents
                ? '<button type="button" class="bcc-drawer__scent-remove" data-bcc-remove-scent="' +
                  escapeHtml(String(scent.index)) +
                  '" data-bcc-line-key="' +
                  escapeHtml(line.key) +
                  '">Remove</button>'
                : '') +
              '</li>'
            );
          })
          .join('') +
        '</ul>';

    return (
      lineArticleOpen(
        line,
        'bcc-drawer__item--bundle' + (isSingle ? ' bcc-drawer__item--single' : '')
      ) +
      imgHtml +
      '<div class="bcc-drawer__item-main">' +
      (line.tag ? '<span class="bcc-drawer__bundle-tag">' + escapeHtml(line.tag) + '</span>' : '') +
      '<h3 class="bcc-drawer__item-name">' +
      escapeHtml(title) +
      '</h3>' +
      scentList +
      priceHtml +
      renderQtyControls(line) +
      '</div>' +
      '<button type="button" class="bcc-drawer__item-remove" data-bcc-remove-line="' +
      escapeHtml(line.key) +
      '">Remove</button>' +
      '</article>'
    );
  }

  function renderItems(state) {
    var wrap = qs('[data-bcc-items]');
    if (!wrap) return;

    var lines = state.lines || [];
    if (!lines.length) {
      wrap.innerHTML = '<p class="bcc-drawer__empty">Your cart is empty.</p>';
      return;
    }

    wrap.innerHTML = lines
      .map(function (line) {
        if (line.type === 'bundle') return renderBundleItem(line);
        return renderLineItem(line);
      })
      .join('');
  }

  function renderTotal(state) {
    var totalEl = qs('[data-bcc-total]');
    var compareEl = qs('[data-bcc-compare-total]');
    if (totalEl) totalEl.textContent = formatMoney(state.totalCents || 0);
    if (compareEl) {
      if (state.compareCents && state.compareCents > state.totalCents) {
        compareEl.textContent = formatMoney(state.compareCents);
        compareEl.hidden = false;
      } else {
        compareEl.textContent = '';
        compareEl.hidden = true;
      }
    }
    renderShipping(state.totalCents || 0);
  }

  function renderUpsell() {
    var track = qs('[data-bcc-upsell-track]');
    var section = qs('[data-bcc-upsell]');
    if (!track || !section) return;

    if (!upsellProducts.length) {
      section.hidden = true;
      return;
    }

    section.hidden = false;
    track.innerHTML = upsellProducts
      .map(function (p) {
        var img = p.image || '';
        var price = formatMoney(p.price);
        var compare =
          p.compare_at_price && p.compare_at_price > p.price
            ? '<s>' + formatMoney(p.compare_at_price) + '</s>'
            : '';
        return (
          '<div class="bcc-drawer__upsell-card">' +
          (img ? '<img src="' + escapeHtml(img) + '" alt="" width="140" height="110" loading="lazy">' : '') +
          '<p class="bcc-drawer__upsell-name">' +
          escapeHtml(p.title) +
          '</p>' +
          '<p class="bcc-drawer__upsell-prices"><span class="is-sale">' +
          price +
          '</span>' +
          compare +
          '</p>' +
          '<button type="button" class="bcc-drawer__upsell-add" data-bcc-upsell-add="' +
          escapeHtml(String(p.variant_id)) +
          '">+ Add to Cart</button>' +
          '</div>'
        );
      })
      .join('');
    bindUpsellNav();
  }

  function bindUpsellNav() {
    var track = qs('[data-bcc-upsell-track]');
    var prev = qs('[data-bcc-upsell-prev]');
    var next = qs('[data-bcc-upsell-next]');
    if (!track || !prev || !next) return;

    function updateNav() {
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
    }

    prev.onclick = function () {
      track.scrollBy({ left: -160, behavior: 'smooth' });
    };
    next.onclick = function () {
      track.scrollBy({ left: 160, behavior: 'smooth' });
    };
    track.onscroll = updateNav;
    updateNav();
  }

  function bindEvents() {
    if (!drawerEl || drawerEl.dataset.bccBound) return;
    drawerEl.dataset.bccBound = '1';

    drawerEl.querySelectorAll('[data-bcc-close]').forEach(function (el) {
      el.addEventListener('click', function () {
        close(true);
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen) close(true);
    });

    drawerEl.addEventListener('click', function (e) {
      if (Date.now() < overlayCloseBlockedUntil) return;
      var overlay = qs('.bcc-drawer__overlay');
      if (overlay && (e.target === overlay || e.target.classList.contains('bcc-drawer__overlay'))) {
        close(true);
      }
    });

    drawerEl.addEventListener('click', function (e) {
      if (drawerEl.classList.contains('is-busy')) return;

      var itemEl;
      var lineKey;
      var curQty;

      var minusBtn = e.target.closest('[data-bcc-qty-minus]');
      if (minusBtn && !minusBtn.disabled && callbacks.onChangeQuantity) {
        e.preventDefault();
        e.stopPropagation();
        itemEl = minusBtn.closest('[data-bcc-item]');
        lineKey = minusBtn.getAttribute('data-bcc-qty-minus');
        curQty = itemEl ? parseInt(itemEl.getAttribute('data-bcc-qty'), 10) : NaN;
        if (!curQty || curQty < 1) curQty = 1;
        callbacks.onChangeQuantity(lineKey, curQty - 1);
        return;
      }

      var plusBtn = e.target.closest('[data-bcc-qty-plus]');
      if (plusBtn && callbacks.onChangeQuantity) {
        e.preventDefault();
        e.stopPropagation();
        itemEl = plusBtn.closest('[data-bcc-item]');
        lineKey = plusBtn.getAttribute('data-bcc-qty-plus');
        curQty = itemEl ? parseInt(itemEl.getAttribute('data-bcc-qty'), 10) : NaN;
        if (!curQty || curQty < 1) curQty = 1;
        callbacks.onChangeQuantity(lineKey, curQty + 1);
        return;
      }

      var removeLineBtn = e.target.closest('[data-bcc-remove-line]');
      if (removeLineBtn && callbacks.onRemoveLine) {
        e.preventDefault();
        e.stopPropagation();
        callbacks.onRemoveLine(removeLineBtn.getAttribute('data-bcc-remove-line'));
        return;
      }

      var removeScentBtn = e.target.closest('[data-bcc-remove-scent]');
      if (removeScentBtn && callbacks.onRemoveScent) {
        e.preventDefault();
        e.stopPropagation();
        callbacks.onRemoveScent(
          removeScentBtn.getAttribute('data-bcc-line-key'),
          parseInt(removeScentBtn.getAttribute('data-bcc-remove-scent'), 10)
        );
        return;
      }

      var upsellBtn = e.target.closest('[data-bcc-upsell-add]');
      if (upsellBtn && callbacks.onUpsellAdd) {
        e.preventDefault();
        e.stopPropagation();
        upsellBtn.disabled = true;
        upsellBtn.classList.add('is-loading');
        callbacks.onUpsellAdd(parseInt(upsellBtn.getAttribute('data-bcc-upsell-add'), 10));
      }
    });

    var checkoutBtn = qs('[data-bcc-checkout]');
    if (checkoutBtn) {
      checkoutBtn.addEventListener('click', function () {
        if (callbacks.onCheckout) callbacks.onCheckout();
      });
    }
  }

  function render(state) {
    if (!drawerEl || !state) return;
    renderItems(state);
    renderTotal(state);
  }

  function setBusy(busy) {
    if (!drawerEl) return;
    drawerEl.classList.toggle('is-busy', !!busy);
    var loader = qs('[data-bcc-loading]');
    if (loader) loader.hidden = !busy;
    if (!busy) {
      drawerEl.querySelectorAll('[data-bcc-upsell-add].is-loading').forEach(function (btn) {
        btn.disabled = false;
        btn.classList.remove('is-loading');
      });
    }
  }

  function open() {
    if (!drawerEl) return;
    drawerEl.hidden = false;
    drawerEl.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(function () {
      drawerEl.classList.add('is-open');
      bindUpsellNav();
    });
    document.body.style.overflow = 'hidden';
    isOpen = true;
  }

  function close(userDismissed) {
    if (!drawerEl) return;
    drawerEl.classList.remove('is-open');
    drawerEl.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    isOpen = false;
    window.setTimeout(function () {
      if (!isOpen) drawerEl.hidden = true;
    }, 320);
    if (userDismissed && typeof onCloseCallback === 'function') onCloseCallback();
  }

  function init(el, options) {
    drawerEl = el;
    callbacks = (options && options.callbacks) || {};
    moneyFormat = (options && options.moneyFormat) || moneyFormat;
    freeShipThreshold = (options && options.freeShippingThreshold) || 0;
    upsellProducts = (options && options.upsellProducts) || [];
    onCloseCallback = options && options.onClose;

    try {
      var upsellJson = el.querySelector('[data-bcc-upsell-data]');
      if (upsellJson && upsellProducts.length === 0) {
        upsellProducts = JSON.parse(upsellJson.textContent || '[]');
      }
    } catch (e) {}

    bindEvents();
    renderUpsell();
  }

  window.BadassCrewCartDrawer = {
    init: init,
    render: render,
    open: open,
    close: close,
    setBusy: setBusy,
    suppressOverlayClose: function (ms) {
      overlayCloseBlockedUntil = Date.now() + (parseInt(ms, 10) || 500);
    },
    isOpen: function () {
      return isOpen;
    }
  };
})();
